export const ADD_NOTIFICATION = 'admin/notification/add'
export const REMOVE_NOTIFICATION = 'admin/notification/remove'
